<template>
  <div class="app container" id="home">
    <Logo />
    <Logo-text />
  </div>
</template>

<script>
import LogoText from "./Partials/Logo-text.vue";
import Logo from "./Partials/Logo.vue";
export default {
  name: "Homepage",
  components: { Logo, LogoText }
};
</script>

<style lang="scss">
.app {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media screen and (min-width: 768px) {
  .app {
    flex-direction: row-reverse;
    justify-content: space-evenly;
    padding: 0 105px;
    &.container {
      max-width: 1200px;
    }
  }
}
</style>
